import { NavLink } from "react-router-dom";
import { useState } from "react";
import './Header.css';
import ThemeChange from './ThemeChange';
import { MdMenu, MdClose, MdAccountCircle } from "react-icons/md";
import logo from '../../logo.svg'

export default function Header() {
  const Link = ({ isActive }) => `navLink ${isActive ? "active" : ""}`;
  const mobileLink = ({ isActive }) => `mobileNavLink ${isActive ? "active" : ""}`;

  const [open, setOpen] = useState(false);
  const [openUser, setOpenUser] = useState(false);
  const [mobileOpenUser, setMobileOpenUser] = useState(false);
  
  const navigation = [
    { to: "/", label: "Index", end: true },
    { to: "/resource", label: "Resource" },
    { to: "/blog", label: "Blog" },
    { to: "/contact", label: "Contact" },
  ];

  return (

    <>
      <header className="header">
        <div className="headerContainer">
          <div className="logoContainer">
            <span className="logoName">Explorelrt</span>
            <img src={logo} alt="Explorelrt Logo" className="logoImage" />
          </div>

          <nav className="navbar">
            {navigation.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={Link}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

        </div>

        <button className="userButton" onClick={() => setOpenUser((prev) => !prev)} aria-expanded={openUser}>
          {openUser ? <MdClose aria-hidden="true" className="closeIcon" /> : <MdAccountCircle aria-hidden="true" className="userIcon" />}
        </button>

      </header>

      {openUser &&
        <div className="userDropdownContainer">

            <div className="userDropdownLinkItem"><NavLink to="/user/Profile" className={Link}>Profile</NavLink></div>
            <div className="userDropdownLinkItem"><NavLink to="/user/Auth" className={Link}>SignIn/SignUp</NavLink></div>
            <div className="userDropdownLinkItem"><ThemeChange id="desktop-theme-toggle" /></div>

        </div>
      }


      <header className="mobileHeader">

        <div className="mobileHeaderContainer">

          <div className="mobileLogoContainer">
            <span className="logoName">Explorelrt</span>
            <img src={logo} alt="Explorelrt Logo" className="logoImage" />
          </div>


          <button
            type="button"
            onClick={() => setOpen((currentOpen) => !currentOpen)}
            className="mobileMenuButton"
            aria-label={open ? "Close navigation menu" : "Open navigation menu"}
            aria-expanded={open}
            aria-controls="mobile-navigation"
          >
            {open ? <MdClose aria-hidden="true" className="mobileCloseIcon" /> : <MdMenu aria-hidden="true" className="mobileMenuIcon" />}
          </button>


          {open &&

            <div className="mobileSidebar" id="mobile-navigation">

              <nav className="mobileNavbar">
                {navigation.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    end={item.end}
                    className={mobileLink}
                    onClick={() => setOpen(false)}
                  >
                    {item.label}
                  </NavLink>
                ))}
              </nav>



              <button className="mobileUserButton" onClick={() => setMobileOpenUser(prev => !prev)} aria-expanded={mobileOpenUser} aria-label="Account Circle">
                { mobileOpenUser ? <MdClose aria-hidden="true" className="mobileCloseIcon" /> : <MdAccountCircle aria-hidden="true" className="mobileUserIcon" /> }
              </button>
              {mobileOpenUser && <div className="mobileUserDropdown">
                <NavLink to="/user/Profile" className={mobileLink}>Profile</NavLink>
                <NavLink to="/user/Auth" className={mobileLink}>SignIn/SignUp</NavLink>
                <ThemeChange id="mobile-theme-toggle" />
              </div>}


            </div>


          }
        </div>

      </header>

    </>
  );
}
